import {
  SHDotGroup,
  SHHtmlBlock,
  SHStack,
  SHStackProps,
} from "@components/design-systems";
import { useTheme } from "@mui/material";
import { memo } from "react";
import { FieldGroupProps } from "../field-group";

type SHFieldGroupMemoProps = FieldGroupProps & SHStackProps;
export const SHFieldGroupMemo = memo(
  ({ children, firstLine, maxWidth, ...others }: SHFieldGroupMemoProps) => {
    return (
      <SHStack
        spacing={3}
        sx={{ paddingY: 3, paddingTop: firstLine ? 0 : 3 }}
        alignItems={"stretch"}
        justifyContent={"space-between"}
        direction={{ xs: "column", md: "row" }}
      >
        <SHStack sx={{ maxWidth: firstLine ? undefined : maxWidth ?? "260px" }}>
          <SHFieldGroupMemoLeftSide {...others} />
        </SHStack>
        <SHStack direction="column">{children}</SHStack>
      </SHStack>
    );
  },
);

const SHFieldGroupMemoLeftSide = memo(
  ({
    title,
    subTitle,
    subTitleColor,
    icon,
    postfixLabel,
    required,
    firstLine,
    dotGroupProps,
    disabled,
  }: SHFieldGroupMemoProps) => {
    const { palette } = useTheme();

    return (
      <>
        <SHStack direction="row" spacing={1} alignItems="center">
          {icon}
          <SHStack direction="row" spacing={0.5} alignItems="start">
            {typeof title === "string" ? (
              <SHHtmlBlock
                variant={firstLine ? "subtitle1" : "subtitle2"}
                textAlign={"left"}
                content={title}
                color={disabled ? palette.text.disabled : palette.text.primary}
              ></SHHtmlBlock>
            ) : (
              title
            )}
            <SHDotGroup redDot={required} paddingTop={"5px"} />
            <SHDotGroup {...dotGroupProps} paddingTop={"5px"} />
          </SHStack>
          <SHStack direction="row" spacing={1} alignItems="center" pb={"5px"}>
            {postfixLabel}
          </SHStack>
        </SHStack>

        {typeof subTitle === "string" ? (
          <SHHtmlBlock
            variant="body4"
            color={subTitleColor ? subTitleColor : palette.text.third}
            content={subTitle}
          />
        ) : (
          subTitle
        )}
      </>
    );
  },
);
